"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
exports.default = react_jss_1.createUseStyles({
    breadcrumbs: {
        display: 'flex',
    },
    breadcrumb: {
        lineHeight: 1,
        whiteSpace: 'nowrap',
        WebkitTapHighlightColor: 'transparent',
    },
    separator: function (_a) {
        var theme = _a.theme;
        return ({
            marginLeft: theme.spacing.xs,
            marginRight: theme.spacing.xs,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[7],
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        });
    },
}, { link: true });
